import { createCommand } from "lexical";
const UPDATE_TOOLBAR_COMMAND = createCommand();
export {
  UPDATE_TOOLBAR_COMMAND
};
//# sourceMappingURL=commands.js.map
